const ReviewsService = {
	index: async (teamId, params) => {
		const response = await axios.get(`/api/reviews/${teamId}`, { params });
		const data = await response.data;
		return data;
	},
	stats: async (teamId) => {
		const response = await axios.get(`/api/reviews/${teamId}/stats`);
		const data = await response.data;
		return data;
	},
	markAsSeen: async (teamId) => {
		if (window.location.pathname.includes('iframe')) {
			return true;
		}
		const response = await axios.post(`/api/reviews/${teamId}/markAsSeen`, {});
		await response.data;
		return true;
	},
};

export default ReviewsService;
